import { apiClient } from './client';
import type { SLAPolicy } from '../types';

export const slaApi = {
  list: async () => {
    const res = await apiClient.get('/sla');
    return res.data.data.policies as SLAPolicy[];
  },

  get: async (id: string) => {
    const res = await apiClient.get(`/sla/${id}`);
    return res.data.data.policy as SLAPolicy;
  },

  create: async (data: Partial<SLAPolicy> & { name: string }) => {
    const res = await apiClient.post('/sla', data);
    return res.data.data.policy as SLAPolicy;
  },

  update: async (id: string, data: Partial<SLAPolicy>) => {
    const res = await apiClient.put(`/sla/${id}`, data);
    return res.data.data.policy as SLAPolicy;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/sla/${id}`);
  },
};
